module.exports = "<svg viewBox=\"0 0 21.3 16.2\"><path fill=\"#231F20\" d=\"M11.8 16.2c-2.5 0-3-3.4-3.4-6.7L8.1 8c-.5-3.3-2-5.3-2.5-5.4-.8 0-3 1.5-3.8 2.6-.3.5-.9.6-1.4.3-.4-.3-.5-1-.2-1.4C1.1 2.9 3.7.6 5.6.6c2.2 0 4 3.6 4.5 7.1.1.5.2 1 .2 1.6.2 1.7.7 4.9 1.5 4.9 1.3 0 3.7-2 5.4-4.6 1.7-2.5 2.5-5.9 1.8-7-.3-.3-.6-.5-1.1-.6-.9-.1-1.9.3-2.4.7-.4.4-1 .3-1.4-.1-.4-.4-.3-1 .1-1.4.8-.7 2.3-1.4 3.9-1.2 1 .1 1.9.6 2.5 1.4 1.6 2.2 0 6.8-1.7 9.3-1.4 2-4.4 5.5-7.1 5.5z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/vimeo.svg
// module id = 321
// module chunks = 1